cockpitApp.directive('flightBodyOptions', function () {
  return {
    restrict: 'E',
    replace: true,
    templateUrl: '/element/flight/body/options',
    controllerAs: 'flightBodyOptionsCtrl',
    controller: 'flightBodyOptionsController'
  };
});
